/** English of Shefira's Aerie and its raid (ADR 0068, 0069), keyed by the exact French phrase. See `index.ts`. */
export const AERIE: Readonly<Record<string, string>> = {
  // game/aerie/aerie-client.ts
  'La crevasse reste close.': 'The crevasse stays shut.',
  'Les harpons la clouent au sol : frappez !': 'The harpoons pin her to the ground: strike!',
  'Shefira redescend.': 'Shefira comes back down.',
  'Shefira plonge sur toi : écarte-toi de son ombre !':
    'Shefira is diving at you: get out of her shadow!',
  'L’anneau de feu se resserre : reste à {rings} cases d’elle au plus !':
    'The ring of fire closes in: stay within {rings} tiles of her!',
  '{post} : prêt dans {seconds} s.': '{post}: ready in {seconds} s.',
  '{name} : « {line} »': '{name}: “{line}”',
  'Shefira prend son envol : harponnez-la depuis deux balistes opposées !':
    'Shefira takes flight: harpoon her from two opposite ballistae!',
  'Shefira prend son envol : Nella prépare son harpon.':
    'Shefira takes flight: Nella readies her harpoon.',
  'Shefira enrage : l’anneau de feu va se resserrer autour d’elle.':
    'Shefira is enraged: the ring of fire will close in around her.',
  '{name} plante le second harpon : Shefira est clouée !':
    '{name} lands the second harpoon: Shefira is pinned!',
  '{name} plante un harpon. Un second, depuis la baliste d’en face !':
    '{name} lands a harpoon. A second one, from the ballista across!',
  'Le voile de givre d’Ulfar te protège.': "Ulfar's veil of frost shields you.",
  '{name} allume le brasero de givre d’Ulfar.': "{name} lights Ulfar's frost brazier.",
  '{name} allume son brasero de givre : abrite-toi dans le voile !':
    '{name} lights a frost brazier: shelter in the veil!',
  'Le cor de Maëlle sonne : son prochain piqué sera annoncé plus tôt.':
    "Maëlle's horn sounds: her next dive will be called out earlier.",
  '{name} sonne le cor de Maëlle : le prochain piqué sera annoncé plus tôt.':
    "{name} sounds Maëlle's horn: the next dive will be called out earlier.",
  // In the world's bitmap font (aerie-client.ts `worldText`).
  'CLOUÉE !': 'PINNED!',
  'PIQUÉ !': 'DIVE!',
  GIVRE: 'FROST',
  SCEAU: 'SEAL',
  RACINES: 'ROOTS',
  // game/aerie/stations.ts
  'Baliste de Nella': "Nella's Ballista",
  'Brasero de givre d’Ulfar': "Ulfar's Frost Brazier",
  'Cor de Maëlle': "Maëlle's Horn",
  'Ce poste n’existe pas.': 'This post does not exist.',
  'Approche-toi du poste.': 'Get closer to the post.',
  'Ce poste n’est pas encore prêt.': 'This post is not ready yet.',
  'Pas maintenant : ce poste ne sert à rien pour l’instant.':
    'Not now: this post is of no use at the moment.',
  // ui/aerie-gate-panel.ts
  'La dernière garde': 'The Last Stand',
  'Entrer seul (histoire)': 'Enter alone (story)',
  'Lancer le raid': 'Launch the raid',
  'Raid ({min} à {max} joueurs, niveau 20)': 'Raid ({min} to {max} players, level 20)',
  'La crevasse s’ouvre sous tes pieds…': 'The crevasse opens beneath your feet…',
  // ui/aerie-text.ts
  'La crevasse n’est pas ici.': 'The crevasse is not here.',
  'Approche-toi de la crevasse.': 'Get closer to the crevasse.',
  'La Compagnie ne t’attend pas ici : la dernière garde n’est pas en cours.':
    'The Company is not waiting for you here: the last stand is not under way.',
  'Seul le chef du groupe, ou d’une alliance, lance le raid.':
    'Only the leader of the party, or of an alliance, launches the raid.',
  'Il faut au moins {min} joueurs pour le raid.': 'The raid needs at least {min} players.',
  'Pas plus de {max} joueurs dans le raid.': 'No more than {max} players in the raid.',
  'Tout le raid doit être niveau {level}.': 'The whole raid must be level {level}.',
  '{name} n’est pas encore niveau {level}.': '{name} is not level {level} yet.',
  'Chacun doit d’abord avoir mené la dernière garde de la Compagnie.':
    "Everyone must first have fought the Company's last stand.",
  '{name} n’a pas encore mené la dernière garde de la Compagnie.':
    "{name} has not fought the Company's last stand yet.",
  'Tout le raid doit se tenir à l’entrée de l’Aire.':
    'The whole raid must stand at the entrance of the Aerie.',
  '{name} n’est pas à l’entrée de l’Aire.': '{name} is not at the entrance of the Aerie.',
  'Quelqu’un du raid est déjà ailleurs : réessaie dans un instant.':
    'Someone in the raid is already elsewhere: try again in a moment.',
  Absent: 'Away',
  'Dernière garde à mener': 'Last stand to fight',
  Prêt: 'Ready',
  'Entre seul avec la Compagnie : Ser Givrecoeur et les cinq recrues se battent à tes côtés.':
    'Go in alone with the Company: Ser Givrecoeur and the five recruits fight at your side.',
  'L’histoire de la dernière garde n’est pas en cours pour toi.':
    'The story of the last stand is not under way for you.',
  'Le raid est prêt : {count} joueurs.': 'The raid is ready: {count} players.',
  'Forme un groupe de {min} à 5 joueurs, ou une alliance de deux groupes (jusqu’à {max}).':
    'Form a party of {min} to 5 players, or an alliance of two parties (up to {max}).',
  'Au sol': 'On the ground',
  'En vol': 'In flight',
  Enragée: 'Enraged',
  'Hors d’atteinte': 'Out of reach',
  'Hors d’atteinte · se pose dans {seconds} s': 'Out of reach · lands in {seconds} s',
  'Harpons {count}/2': 'Harpoons {count}/2',
  'Raid de {count}': 'Raid of {count}',
  'Shefira est vaincue !': 'Shefira is defeated!',
  'Shefira s’enfuit, l’épée au flanc': 'Shefira flees, the sword in her flank',
  'La Compagnie est tombée': 'The Company has fallen',
  'Tu as déjà eu ton butin de Shefira cette semaine.':
    "You've already had your loot from Shefira this week.",
  'Ton butin t’attend à ses pieds.': 'Your loot awaits you at her feet.',
  'Ser Givrecoeur a planté son épée. La dernière garde est tenue.':
    'Ser Givrecoeur has planted his sword. The last stand is held.',
  'Relève-toi et reviens la défier.': 'Get up and come back to challenge her.',
  'Retour à la Brèche dans {seconds} s': 'Back to the Breach in {seconds} s',
  // ui/alliance-client.ts
  'Proposition d’alliance envoyée à {name}.': 'Alliance offer sent to {name}.',
  'Alliance conclue avec le groupe de {name}.': "Alliance made with {name}'s party.",
  '{name} décline l’alliance.': '{name} declines the alliance.',
  '{name} n’a pas répondu à la proposition d’alliance.':
    '{name} did not answer the alliance offer.',
  'L’alliance avec le groupe de {name} est rompue.': "The alliance with {name}'s party is broken.",
  '{name} propose une alliance à ton groupe pour le raid de Shefira.':
    "{name} offers your party an alliance for Shefira's raid.",
  'Ce joueur ne mène pas de groupe.': 'This player does not lead a party.',
  'Un des deux groupes a déjà une alliance.': 'One of the two parties already has an alliance.',
  'Deux groupes au plus, dix joueurs au plus.': 'Two parties at most, ten players at most.',
  "Ton groupe n'a pas d'alliance.": 'Your party has no alliance.',
  // ui/party-frames.ts, ui/social-client.ts
  'Alliance : groupe de {leader} ({count})': "Alliance: {leader}'s party ({count})",
  'Rompre l’alliance': 'Break the alliance',
  'Proposer une alliance': 'Offer an alliance',
};
